import { Component } from '@angular/core';

@Component({
    selector: 'app-cancelled-orders',
    templateUrl: './cancelled-orders.component.html',
    styleUrl: './cancelled-orders.component.scss',
    standalone: false
})
export class CancelledOrdersComponent {

}
